import { createContext } from 'react'

interface ShowMoreContextType {
  showMoreDetails: boolean
}

export const ShowMoreContext = createContext<null | ShowMoreContextType>(null)
